<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { getAuthenticationContext } from "./context";

  export let mode: "signup" | "login";
  export let preventSignup: boolean = false;
  export let requireTOSAcceptance: boolean = false;

  const dispatcher = createEventDispatcher();
  const context = getAuthenticationContext();

  let buttonElement: HTMLButtonElement;

  function onClick(e: MouseEvent) {
    if (!$context.inlineOAuth) {
      e.stopPropagation();
      e.preventDefault();
    }

    if (requireTOSAcceptance) {
      dispatcher("clickWhileTOSRequired");
      return;
    }

    continueWithGoogle();
  }

  export function continueWithGoogle() {
    const url = new URL(`/app/users/google_connect?mode=${mode}`, document.location.href);

    if (mode === "signup") {
      url.searchParams.append("signup_button", "signup-page-google-connect");
    }
    if ($context.inviteToken && $context.inviteToken.length > 0) {
      url.searchParams.append("invite_token", $context.inviteToken);
    }

    document.location.href = url.toString();
  }
</script>

<button
  bind:this={buttonElement}
  on:click={onClick}
  id={$context.inlineOAuth ? undefined : "google-connect-button"}
  data-prevent-signup={preventSignup ? "true" : ""}
  class="focusable clickable flex w-full items-center justify-center overflow-hidden rounded border border-nxgray-500 bg-white text-16 font-semibold text-primary outline-none hover:bg-nxgray-50 focus:outline-none">
  <div class="google-icon" />
  <div>Continue with Google</div>
</button>

<style>
  .google-icon {
    background-image: url("./images/google-logo.svg");
    background-repeat: no-repeat;
    background-position: center;
    width: 42px;
    height: 42px;
  }
</style>
